<script>
    import {store} from '../stores.js';
    import Sidebar from './Sidebar.svelte';

    const user = store('credentials', 'appUserAuth');
    
    export let title = '';
    
    let scroll = () => document.querySelector('.appHeader').classList.toggle('is-active', window.scrollY >= 56);
</script>

<svelte:window on:scroll={scroll} />

<!-- App Header -->
<div class="appHeader bg-primary scrolled" {...$$restProps}>
    {#if $user.id || $user.idRegPred }
        <div class="left">
            <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#sidebarPanel">
                <ion-icon name="menu-outline"></ion-icon>
            </a>
        </div>
    {/if}
    
    <div class="pageTitle d-none d-md-block">{@html (title ? title : '<span class="placeholder col-7"></span>')}</div>
    
    {#if $user.id || $user.idRegPred }
        <div class="right">
            <slot name="back"></slot>
            <slot name="left"></slot>
            <slot name="add"></slot>
            <slot name="edit"></slot>
            <slot name="remove"></slot>
            <slot name="right"></slot>
        </div>
    {/if}
</div>
<!-- * App Header -->

{#if $user.id || $user.idRegPred }
    <Sidebar />
{/if}
